export const PRICING_FEATURE_CODE_MAX_LENGTH = 120;

const CODE_CHARS_PATTERN = /^[a-z0-9-]*$/;
const CODE_VALUE_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** Aceita o valor enquanto o usuário digita (vazio ou hífen no final). */
export function isPricingFeatureCodeInput(value: string): boolean {
  if (value === '') {
    return true;
  }

  if (value.startsWith('-') || value.includes('--')) {
    return false;
  }

  return CODE_CHARS_PATTERN.test(value) && value.length <= PRICING_FEATURE_CODE_MAX_LENGTH;
}

/** Código no formato final: minúsculas, números e hífen, sem começar/terminar com hífen. */
export function isValidPricingFeatureCode(value: string): boolean {
  return CODE_VALUE_PATTERN.test(value) && value.length <= PRICING_FEATURE_CODE_MAX_LENGTH;
}
